import { Action, createReducer, on } from "@ngrx/store";

import { Guest, User } from "@hermes/api-model-account";

import {
    clearUserData,
    fetchGuestSuccess,
    removeGuestSuccess,
    setUser,
} from "../actions/user.actions";

import { initialState, UserState } from "./user.state";

export const userFeatureKey = "user";

const fetchGuestSuccessReducer = (
    state: UserState,
    action: ReturnType<typeof fetchGuestSuccess>,
): UserState => ({
    ...state,
    userStatus: "synchronized",
    guest: action.guest,
});

const removeGuestSuccessReducer = (state: UserState): UserState => ({
    ...state,
    guest: undefined as unknown as Guest,
});

const setUserReducer = (
    state: UserState,
    action: ReturnType<typeof setUser>,
): UserState => ({
    ...state,
    userStatus: "synchronized",
    details: {
        ...action.user,
        basket: undefined,
        shippingAddresses: undefined,
    } as unknown as User,
});

const clearUserDataReducer = (): UserState => ({
    ...initialState,
    userStatus: "synchronized",
});

const userReducer = createReducer(
    initialState,
    on(fetchGuestSuccess, fetchGuestSuccessReducer),
    on(removeGuestSuccess, removeGuestSuccessReducer),
    on(setUser, setUserReducer),
    on(clearUserData, clearUserDataReducer),
);

export function reducer(
    state: UserState | undefined,
    action: Action,
): UserState {
    return userReducer(state, action);
}
